export default __webpack_public_path__ + "static/media/icons-background-mobile.c75f0df9.jpg";